import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, RootStateOrAny } from "react-redux";
import { CookiesWarning } from "components/CookiesWarning";
import {
  Banner,
  BannerStudio,
  BannerAbf,
  Valentine,
  BannerOrofacial,
  BannerEaster,
  AdvancedTecnology,
  BannerInvisalign,
  Braces,
  Game,
  SponsorsFullPage,
  SponsorsHalfPage,
  Treatments,
  Surfers,
  OrangeJulyComponent,
  BannerPais,
  BannerMusic,
  BannerFlamengo,
  BannerPrevencaoKids,
} from "components/Home";
import {
  Booking,
  Footer,
  Franchising,
  Modal,
  Scaffold,
} from "components/Shared";

import { FetchTagIndexActions } from "store/ducks/unidades";

import * as S from "./styles";

export const Home: React.FC = () => {
  const dispatch = useDispatch();
  const [popupOpen, setPopupOpen] = useState<boolean>(true);
  const [bannerIndex, setBannerIndex] = useState<number>(0);

  function redirectPop() {
    window.location.href = "https://orthopride.com.br/agendar-avaliacao";
  }

  useEffect(() => {
    dispatch(FetchTagIndexActions.request("general"));
  }, [dispatch]);

  // controle de rotacao dos banners
  const totalBanners = 3;
  useEffect(() => {
    const intervalId = setInterval(() => {
      setBannerIndex((prevIndex) => {
        //const nextIndex = prevIndex === 0 ? 1 : 0;
        const nextIndex = (prevIndex + 1) % totalBanners;
        console.log("Alternando banner para:", nextIndex);
        return nextIndex;
      });
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  const renderBanner = () => {
    switch (bannerIndex) {
      case 0:
        return <BannerPrevencaoKids key="0" />;
      case 1:
        return <BannerOrofacial key="0" />;
      case 2:
        return <BannerInvisalign key="1" />;

      default:
        return <BannerOrofacial key="0" />;
    }
  };

  return (
    <>
      {/* <Modal isOpen={popupOpen} onClickOutside={() => setPopupOpen(true)}>
        <S.Popup>
          <S.Close onClick={() => setPopupOpen(false)}>&times;</S.Close>
          <S.PopupContent onClick={redirectPop} />
        </S.Popup>
      </Modal> */}

      <Scaffold>
        <S.GroupBanner>{renderBanner()}</S.GroupBanner>
        <Braces />
        <Treatments />
        <Game />
        <Franchising />
        <Surfers />
        <BannerFlamengo />
        <SponsorsFullPage />
        {/* <SponsorsHalfPage /> */}
        <BannerMusic />
        <Booking />
        <Footer />
        <CookiesWarning />
      </Scaffold>
    </>
  );
};
